import { render, staticRenderFns } from "./button.vue?vue&type=template&id=eae7ef7c&"
import script from "./button.vue?vue&type=script&lang=ts&"
export * from "./button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eae7ef7c')) {
      api.createRecord('eae7ef7c', component.options)
    } else {
      api.reload('eae7ef7c', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=eae7ef7c&", function () {
      api.rerender('eae7ef7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button.vue"
export default component.exports